let Hooks = {}

Hooks.UserEdit = {
    mounted() {}
}

export {Hooks}